import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  formattedPrice,
  getBranches,
  getCustomers,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import withPermissions from "../../components/WithPermissions";
import Select from "react-select";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import WithholdingModal from "../../components/Modals/WithholdingModal";
import "../../components/PriceSummary.css";
import "../../components/ModernDropdown.css";

class ManualInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      branches: [],
      tevkifat: [],
      processNames: [],
      selectedCustomer: null,
      selectedTevkifat: '',
      showTevkifatDelButton: false,
      showWithholdingModal: false,
      showDropdown: null,
      filteredProcessNames: [],
      isMobile: false,
      setKdv: false,
      loading: false,
      customerInvoiceType: null, // EFATURA veya EARSIV
      customerInvoiceTypeChecked: false, // Mükellef sorgulaması yapıldı mı?
      checkingTaxPayer: false, // Mükellef sorgulaması devam ediyor mu?
      formData: {
        customer_id: '',
        branch_id: '',
        invoice_date: new Date().toISOString().split('T')[0],
        due_date: '',
        description: '',
        currency: 'TRY',
        withholding_rate: '',
      },
      processes: [{ process: "", price: "", cost: "", kdv: 0, discount: "", unit: "C62", quantity: 1 }],
    };
  }

  async componentDidMount() {
    try {
      const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);
      this.setState({ isMobile });

      await this.getCustomers();
      await this.getBranches();
      await this.getProcessName();
      await this.tevkifat();

      document.addEventListener('mousedown', this.handleClickOutside);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      mainHelper.toastMessage('error', 'Veriler yüklenirken hata oluştu!');
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const dropdownElements = document.querySelectorAll('.modern-dropdown-wrapper');
    let clickedInside = false;

    dropdownElements.forEach(element => {
      if (element.contains(event.target)) {
        clickedInside = true;
      }
    });

    if (!clickedInside && this.state.showDropdown !== null) {
      this.setState({ showDropdown: null });
    }
  };

  getCustomers = async () => {
    try {
      const customers = await getCustomers();
      const customerOptions = customers.map(customer => ({
        value: customer.id,
        label: `${customer.name} ${customer.surname || ''} ${customer.title ? '(' + customer.title + ')' : ''}`,
        data: customer
      }));
      this.setState({ customers: customerOptions });
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  getBranches = async () => {
    try {
      const branches = await getBranches();
      this.setState({ branches });
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  getProcessName = async () => {
    try {
      let localProcessNames = JSON.parse(localStorage.getItem('processNames'));
      if (!localProcessNames) {
        const response = await apiCall('business/operation/get-process-name', 'get');
        localStorage.setItem('processNames', JSON.stringify(response));
        localProcessNames = response;
      }
      this.setState({ processNames: localProcessNames });
    } catch (e) {
      console.error(e);
    }
  };

  tevkifat = async () => {
    try {
      let tevkifatOptions = JSON.parse(localStorage.getItem('tevkifatOptions'));
      if (!tevkifatOptions) {
        const response = await apiCall('business/invoice/tevkifat', 'get', null);
        tevkifatOptions = Object.keys(response).map(key => ({
          value: key,
          label: response[key].name,
          rate: response[key].rate
        }));
        localStorage.setItem('tevkifatOptions', JSON.stringify(tevkifatOptions));
      }
      this.setState({ tevkifat: tevkifatOptions });
    } catch (e) {
      console.error(e);
    }
  };

  handleCustomerChange = async (selectedOption) => {
    this.setState({
      selectedCustomer: selectedOption,
      customerInvoiceType: null,
      customerInvoiceTypeChecked: false,
      formData: {
        ...this.state.formData,
        customer_id: selectedOption ? selectedOption.value : ''
      }
    });

    // Müşteri seçildiyse ve vergi numarası varsa mükellef sorgulaması yap
    if (selectedOption && selectedOption.data && selectedOption.data.tax_no && selectedOption.data.tax_no.length >= 10) {
      await this.checkTaxPayer(selectedOption.data);
    } else if (selectedOption && selectedOption.data) {
      // Vergi numarası yoksa veya geçersizse fatura oluşturma engellenir
      this.setState({
        customerInvoiceType: null,
        customerInvoiceTypeChecked: false
      });

      // Kullanıcıya uyarı göster ve müşteri detayına yönlendir
      Swal.fire({
        title: 'VKN/TCKN Bilgisi Gerekli',
        html: `
          <div style="text-align: left;">
            <p style="margin-bottom: 15px;">
              <strong style="font-size: 15px;">${selectedOption.label}</strong> için 
              <strong style="color: #dc3545;">VKN/TCKN bilgisi bulunamadı.</strong>
            </p>
            <div style="background: #fff3cd; padding: 12px; border-radius: 6px; border-left: 4px solid #ffc107; margin: 15px 0;">
              <p style="margin: 0; color: #856404; font-size: 13px;">
                <i class="fa fa-exclamation-triangle" style="margin-right: 6px;"></i>
                <strong>Fatura oluşturmak için VKN/TCKN bilgisi zorunludur.</strong>
              </p>
            </div>
            <hr style="margin: 15px 0; border-top: 1px solid #e0e0e0;">
            <div style="font-size: 13px; color: #555;">
              <p style="margin: 8px 0;">
                <strong>Yapılması gerekenler:</strong>
              </p>
              <ol style="margin: 8px 0; padding-left: 20px;">
                <li>Müşteri detay sayfasına gidin</li>
                <li>VKN/TCKN bilgisini ekleyin</li>
                <li>"Mükellef Doğrula" butonuna tıklayın</li>
                <li>Kaydet Butonuna tıklayıp kaydedin.</li>
              </ol>
            </div>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-user"></i> Müşteri Detayına Git',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#007bff',
        cancelButtonColor: '#6c757d',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // Müşteri detay sayfasına yönlendir
          this.props.history.push(`/customer-detail/${selectedOption.value}`);
        } else {
          // İptal edilirse müşteri seçimini temizle
          this.setState({
            selectedCustomer: null,
            formData: {
              ...this.state.formData,
              customer_id: ''
            }
          });
        }
      });
    }
  };

  checkTaxPayer = async (customerData) => {
    try {
      this.setState({ checkingTaxPayer: true });

      const tax_no = customerData.tax_no;
      if (!tax_no || tax_no.length < 10) {
        this.setState({
          checkingTaxPayer: false,
          customerInvoiceType: customerData.invoice_type || 'EARSIV',
          customerInvoiceTypeChecked: true
        });
        return;
      }

      const response = await apiCall('business/customer/check-taxpayer/' + tax_no, 'get', null);

      if (response.status === 'error' || !response.data) {
        // Mükellef bilgisi bulunamadı, veritabanındaki değeri kullan veya EARSIV olarak işaretle
        this.setState({
          customerInvoiceType: customerData.invoice_type || 'EARSIV',
          customerInvoiceTypeChecked: true,
          checkingTaxPayer: false
        });
        return;
      }

      const { data } = response;

      // Müşteri bilgilerini güncelle (backend'e gönder)
      const updateData = {
        id: customerData.id,
        urn: data.urn || customerData.urn || '',
        invoice_type: data.invoice_type || 'EARSIV',
        title: data.unvan || customerData.title || ''
      };

      // Müşteri kaydını güncelle
      await apiCall('business/customer/update/' + customerData.id, 'post', updateData);

      // State'i güncelle
      this.setState({
        customerInvoiceType: data.invoice_type || 'EARSIV',
        customerInvoiceTypeChecked: true,
        checkingTaxPayer: false,
        // Seçili müşterinin datasını da güncelle
        selectedCustomer: {
          ...this.state.selectedCustomer,
          data: {
            ...this.state.selectedCustomer.data,
            urn: data.urn || '',
            invoice_type: data.invoice_type || 'EARSIV',
            title: data.unvan || customerData.title || ''
          }
        }
      });

      // LocalStorage'daki customer listesini güncelle
      const customers = await apiCall('business/customer/get-customers', 'get', null);
      localStorage.setItem('customers', JSON.stringify(customers));

      console.log('Mükellef sorgulaması tamamlandı:', {
        customer: customerData.name,
        invoice_type: data.invoice_type,
        urn: data.urn
      });

      // Başarılı sorgu sonrası bilgilendirme göster
      const invoiceTypeText = data.invoice_type === 'EFATURA' ? 'E-Fatura' : 'E-Arşiv';
      const invoiceTypeColor = data.invoice_type === 'EFATURA' ? '#2e7d32' : '#ef6c00';
      const invoiceTypeIcon = data.invoice_type === 'EFATURA' ? 'fa-check-circle' : 'fa-file-text-o';

      Swal.fire({
        title: 'Mükellef Sorgulaması Tamamlandı',
        html: `
          <div style="text-align: left;">
            <p style="margin-bottom: 15px;">
              <strong style="font-size: 16px;">${data.unvan || customerData.title || customerData.name}</strong>
              <br>
              <span style="color: ${invoiceTypeColor}; font-weight: bold; font-size: 14px;">
                <i class="fa ${invoiceTypeIcon}"></i> (${invoiceTypeText} Mükellefi)
              </span>
            </p>
            <hr style="margin: 15px 0; border-top: 1px solid #e0e0e0;">
            <div style="font-size: 13px; color: #555;">
              <p style="margin: 8px 0;">
                <i class="fa fa-barcode" style="width: 20px; color: #666;"></i> 
                <strong>VKN/TCKN:</strong> ${customerData.tax_no}
              </p>
              ${data.urn ? `
                <p style="margin: 8px 0;">
                  <i class="fa fa-envelope" style="width: 20px; color: #666;"></i> 
                  <strong>URN:</strong> <span style="font-size: 11px;">${data.urn}</span>
                </p>
              ` : ''}
              <p style="margin: 8px 0;">
                <i class="fa fa-file-text" style="width: 20px; color: ${invoiceTypeColor};"></i> 
                <strong>Fatura Tipi:</strong> 
                <span style="color: ${invoiceTypeColor}; font-weight: bold;">${invoiceTypeText}</span>
              </p>
            </div>
            <hr style="margin: 15px 0; border-top: 1px solid #e0e0e0;">
            <small style="color: #888; font-size: 12px;">
              <i class="fa fa-info-circle"></i> Müşteri bilgileri otomatik olarak güncellenmiştir.
            </small>
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'Tamam',
        confirmButtonColor: '#007bff',
        timer: 6000,
        timerProgressBar: true
      });

    } catch (error) {
      console.error('checkTaxPayer error:', error);
      // Hata durumunda veritabanındaki değeri kullan
      this.setState({
        customerInvoiceType: customerData.invoice_type || 'EARSIV',
        customerInvoiceTypeChecked: true,
        checkingTaxPayer: false
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSetKdvChange = (event) => {
    const { checked } = event.target;
    this.setState((prevState) => ({
      setKdv: checked,
      processes: checked
        ? prevState.processes.map((process) => ({ ...process, kdv: 20 }))
        : prevState.processes.map((process) => ({ ...process, kdv: 0 }))
    }));
  };

  handleAddProcess = () => {
    this.setState((prevState) => ({
      processes: [...prevState.processes, { process: "", price: "", cost: "", kdv: 0, discount: "", unit: "C62", quantity: 1 }],
    }));
  };

  handleAddMaintenanceProcess = () => {
    const maintenanceItems = [
      "Motor Yağı",
      "Yağ Filtresi",
      "Hava Filtresi",
      "Polen Filtresi",
      "Cam Su İlacı",
      "Temizlik Spreyi",
      "Mekanik Servis Ücreti"
    ];
    this.setState({
      processes: maintenanceItems.map(item => ({
        process: item,
        price: "",
        cost: "",
        kdv: 0,
        discount: "",
        unit: "C62",
        quantity: 1
      }))
    });
  };

  handleRemoveProcess = (index) => {
    this.setState((prevState) => ({
      processes: prevState.processes.filter((_, i) => i !== index),
    }));
  };

  handleProcessChange = (index, field, value) => {
    const filteredProcessNames = this.state.processNames.filter((name) =>
      name.name.trim().includes(value.trim())
    );

    this.setState((prevState) => {
      const updatedProcesses = prevState.processes.map((process, i) =>
        i === index ? { ...process, [field]: value } : process
      );
      return {
        processes: updatedProcesses,
        filteredProcessNames,
        showDropdown: filteredProcessNames.length > 0 && field === "process" ? index : null,
      };
    });
  };

  handleProcessSelect = (index, name) => {
    this.setState((prevState) => {
      const updatedProcesses = prevState.processes.map((process, i) =>
        i === index ? { ...process, process: name } : process
      );
      return { processes: updatedProcesses, showDropdown: null };
    });
  };

  calculateTotals = () => {
    const { processes, formData } = this.state;
    const withholdingRate = parseFloat(formData.withholding_rate) || 0;
    let totalCost = 0;
    let totalPrice = 0;
    let totalWithKdv = 0;
    let totalKdv = 0;
    let totalDiscount = 0;
    let totalWithholding = 0;

    processes.forEach((process) => {
      const cost = parseFloat(process.cost) || 0;
      const quantity = parseFloat(process.quantity) || 0;
      const price = parseFloat(process.price) || 0;
      const kdvRate = parseFloat(process.kdv) || 0;
      const discountRate = parseFloat(process.discount) || 0;

      const discount = (price * quantity * discountRate) / 100;
      totalCost += cost * quantity;
      totalPrice += price * quantity;
      totalDiscount += discount;

      const discountedPrice = (price * quantity) - discount;
      const kdvAmount = (discountedPrice * kdvRate) / 100;

      totalKdv += kdvAmount;
      totalWithKdv += discountedPrice + kdvAmount;

      const withholdingAmount = (kdvAmount * withholdingRate) / 100;
      totalWithholding += withholdingAmount;

      totalWithKdv -= withholdingAmount;
    });

    totalCost = totalCost.toFixed(2);
    totalPrice = totalPrice.toFixed(2);
    totalWithKdv = totalWithKdv.toFixed(2);
    totalKdv = totalKdv.toFixed(2);
    totalDiscount = totalDiscount.toFixed(2);
    totalWithholding = totalWithholding.toFixed(2);

    return { totalCost, totalPrice, totalWithKdv, totalKdv, totalDiscount, totalWithholding };
  };

  toggleWithholdingModal = () => {
    this.setState(prevState => ({
      showWithholdingModal: !prevState.showWithholdingModal
    }));
  };

  handleTevkifatChange = (selectedOption) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        withholding_rate: selectedOption.rate
      },
      selectedTevkifat: selectedOption
    }), () => {
      this.calculateTotals();
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { formData, processes, selectedCustomer } = this.state;
    const { totalPrice, totalKdv, totalDiscount, totalWithholding, totalWithKdv } = this.calculateTotals();

    // Validasyon
    if (!formData.customer_id) {
      mainHelper.toastMessage('error', 'Lütfen müşteri seçiniz!');
      return;
    }

    // VKN/TCKN kontrolü
    if (selectedCustomer && selectedCustomer.data && (!selectedCustomer.data.tax_no || selectedCustomer.data.tax_no.length < 10)) {
      Swal.fire({
        title: 'VKN/TCKN Eksik',
        html: `
          <div style="text-align: left;">
            <p style="margin-bottom: 15px;">
              <strong style="color: #dc3545;">Fatura oluşturmak için müşterinin VKN/TCKN bilgisi gereklidir.</strong>
            </p>
            <div style="background: #fff3cd; padding: 12px; border-radius: 6px; border-left: 4px solid #ffc107; margin: 15px 0;">
              <p style="margin: 0; color: #856404; font-size: 13px;">
                <i class="fa fa-exclamation-triangle" style="margin-right: 6px;"></i>
                Müşteri detay sayfasından VKN/TCKN bilgisini ekleyip mükellef doğrulaması yapınız.
              </p>
            </div>
          </div>
        `,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-user"></i> Müşteri Detayına Git',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#007bff',
        cancelButtonColor: '#6c757d',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.history.push(`/customer-detail/${selectedCustomer.value}`);
        }
      });
      return;
    }

    if (!formData.branch_id) {
      mainHelper.toastMessage('error', 'Lütfen şube seçiniz!');
      return;
    }

    if (!formData.invoice_date) {
      mainHelper.toastMessage('error', 'Lütfen fatura tarihi giriniz!');
      return;
    }

    // Process kontrolü
    const hasValidProcess = processes.some(p => p.process && p.price && p.kdv >= 0);
    if (!hasValidProcess) {
      mainHelper.toastMessage('error', 'En az bir ürün/hizmet ekleyiniz ve fiyat, KDV bilgilerini doldurunuz!');
      return;
    }

    this.setState({ loading: true });

    try {
      const data = {
        ...formData,
        processes: JSON.stringify(processes),
        withholding_info: this.state.selectedTevkifat ? JSON.stringify([this.state.selectedTevkifat]) : null,
        total_amount: totalPrice,
        total_vat: totalKdv,
        total_discount: totalDiscount,
        total_withholding: totalWithholding,
        net_total: totalWithKdv,
      };

      const response = await apiCall('business/manual-invoice/create', 'post', data);

      if (response.status === 'success') {
        Swal.fire({
          title: 'Başarılı!',
          text: 'Manuel fatura başarıyla oluşturuldu.',
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'Fatura Detayına Git',
          cancelButtonText: 'Yeni Fatura Oluştur',
        }).then((result) => {
          if (result.isConfirmed) {
            // Fatura detay sayfasına yönlendir
            this.props.history.push(`/manual-invoice-detail/${response.invoice_id}`);
          } else {
            // Formu sıfırla
            this.resetForm();
          }
        });
      }
    } catch (error) {
      console.error('Error creating manual invoice:', error);
      mainHelper.toastMessage('error', error.response?.data?.message || 'Fatura oluşturulurken hata oluştu!');
    } finally {
      this.setState({ loading: false });
    }
  };

  resetForm = () => {
    this.setState({
      selectedCustomer: null,
      selectedTevkifat: '',
      showTevkifatDelButton: false,
      customerInvoiceType: null,
      customerInvoiceTypeChecked: false,
      checkingTaxPayer: false,
      formData: {
        customer_id: '',
        branch_id: '',
        invoice_date: new Date().toISOString().split('T')[0],
        due_date: '',
        description: '',
        currency: 'TRY',
        withholding_rate: '',
      },
      processes: [{ process: "", price: "", cost: "", kdv: 0, discount: "", unit: "C62", quantity: 1 }],
      setKdv: false,
    });
  };

  render() {
    const {
      customers,
      branches,
      tevkifat,
      selectedCustomer,
      selectedTevkifat,
      showWithholdingModal,
      isMobile,
      loading,
      formData,
      processes,
      customerInvoiceType,
      customerInvoiceTypeChecked,
      checkingTaxPayer,
    } = this.state;

    const { totalCost, totalPrice, totalKdv, totalWithKdv, totalDiscount, totalWithholding } = this.calculateTotals();
    const { subscriptionCode } = this.props;
    const code = subscriptionCode !== "none" && subscriptionCode !== "t22Vh3S";

    return (
      <div style={{ flex: 1 }} onClick={() => { document.body.classList.remove("offcanvas-active"); }}>
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Manuel Fatura Oluştur"
              Breadcrumb={[
                { name: "Faturalar", navigate: "service-invoices/draft" },
                { name: "Manuel Fatura", navigate: "" },
              ]}
            />

            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                  <div className="header" style={{
                    background: '#f8f9fa',
                    borderBottom: '2px solid #e9ecef'
                  }}>
                    <h2 style={{ color: '#495057', margin: 0, padding: '20px', display: 'flex', alignItems: 'center', fontWeight: '600' }}>
                      <i className="fa fa-file-text-o" style={{ marginRight: '12px', fontSize: '22px', color: '#6c757d' }}></i>
                      Fatura Bilgileri
                    </h2>
                  </div>
                  <div className="card-body" style={{ padding: '30px' }}>
                    <form onSubmit={this.handleSubmit}>
                      <div className="row">
                        {/* Sol Kolon */}
                        <div className="col-lg-6 col-md-12">
                          {/* Müşteri ve Şube Kartı */}
                          <div style={{
                            background: '#fff',
                            padding: '25px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            border: '2px solid #dee2e6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }}>
                            <div style={{ marginBottom: '25px' }}>
                              <label htmlFor="customer_id" className="font-weight-bold text-cyan">
                                Müşteri <span className="text-danger">*</span>
                              </label>
                              <Select
                                id="customer_id"
                                value={selectedCustomer}
                                onChange={this.handleCustomerChange}
                                options={customers}
                                placeholder="Müşteri seçiniz..."
                                isClearable
                                isSearchable
                                noOptionsMessage={() => "Müşteri bulunamadı"}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderColor: '#ced4da',
                                    borderWidth: '1px',
                                    borderRadius: '6px',
                                    minHeight: '44px',
                                    fontSize: '14px',
                                    boxShadow: 'none',
                                    '&:hover': {
                                      borderColor: '#007bff'
                                    }
                                  })
                                }}
                              />

                              {/* Mükellef Durumu Göstergesi */}
                              {selectedCustomer && (
                                <div style={{ marginTop: '10px' }}>
                                  {checkingTaxPayer ? (
                                    <div style={{
                                      padding: '8px 12px',
                                      background: '#e3f2fd',
                                      borderRadius: '6px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      fontSize: '13px',
                                      color: '#1976d2'
                                    }}>
                                      <ReactLoading type="spin" width={'16px'} height={'16px'} color="#1976d2" />
                                      <span style={{ marginLeft: '8px' }}>Mükellef durumu sorgulanıyor...</span>
                                    </div>
                                  ) : customerInvoiceTypeChecked && customerInvoiceType ? (
                                    <div>
                                      <div style={{
                                        padding: '10px 12px',
                                        background: customerInvoiceType === 'EFATURA' ? '#e8f5e9' : '#fff3e0',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        color: customerInvoiceType === 'EFATURA' ? '#2e7d32' : '#ef6c00',
                                        borderLeft: `4px solid ${customerInvoiceType === 'EFATURA' ? '#2e7d32' : '#ef6c00'}`
                                      }}>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                          <i className={`fa ${customerInvoiceType === 'EFATURA' ? 'fa-check-circle' : 'fa-file-text-o'}`}
                                            style={{ marginRight: '6px', fontSize: '14px' }}></i>
                                          <strong style={{ fontSize: '14px' }}>
                                            {selectedCustomer.data.title || `${selectedCustomer.data.name} ${selectedCustomer.data.surname || ''}`}
                                          </strong>
                                        </div>
                                        <div style={{
                                          marginLeft: '20px',
                                          fontSize: '12px',
                                          fontWeight: '600',
                                          color: customerInvoiceType === 'EFATURA' ? '#1b5e20' : '#e65100'
                                        }}>
                                          ({customerInvoiceType === 'EFATURA' ? 'E-Fatura Mükellefi' : 'E-Arşiv Mükellefi'})
                                        </div>
                                      </div>
                                    </div>
                                  ) : (!selectedCustomer.data.tax_no || selectedCustomer.data.tax_no.length < 10) ? (
                                    <div style={{
                                      padding: '10px 12px',
                                      background: '#ffebee',
                                      borderLeft: '4px solid #dc3545',
                                      borderRadius: '6px',
                                      fontSize: '13px',
                                      color: '#721c24'
                                    }}>
                                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                                        <i className="fa fa-times-circle" style={{ marginRight: '6px', fontSize: '16px', color: '#dc3545' }}></i>
                                        <strong>VKN/TCKN Tanımlı Değil</strong>
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#856404', marginLeft: '22px' }}>
                                        Fatura oluşturmak için mükellef doğrulaması gereklidir.
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                            </div>

                            <div>
                              <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                                Şube <span className="text-danger">*</span>
                              </label>
                              <select
                                name="branch_id"
                                id="branch_id"
                                className="form-control"
                                value={formData.branch_id}
                                onChange={this.handleChange}
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              >
                                <option value="">Şube seçiniz...</option>
                                {branches.map((branch) => (
                                  <option key={branch.id} value={branch.id}>
                                    {branch.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Tarihler Kartı */}
                          <div style={{
                            background: '#fff',
                            padding: '25px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            border: '2px solid #dee2e6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }}>
                            <div style={{ marginBottom: '25px' }}>
                              <label htmlFor="invoice_date" className="font-weight-bold text-cyan">
                                Fatura Tarihi <span className="text-danger">*</span>
                              </label>
                              <input
                                type="date"
                                name="invoice_date"
                                id="invoice_date"
                                className="form-control"
                                value={formData.invoice_date}
                                onChange={this.handleChange}
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>

                            <div>
                              <label htmlFor="due_date" className="font-weight-bold text-cyan">
                                Vade Tarihi
                              </label>
                              <input
                                type="date"
                                name="due_date"
                                id="due_date"
                                className="form-control"
                                value={formData.due_date}
                                onChange={this.handleChange}
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Sağ Kolon - Açıklama */}
                        <div className="col-lg-6 col-md-12">
                          <div style={{
                            background: '#fff',
                            padding: '25px',
                            borderRadius: '8px',
                            border: '2px solid #dee2e6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                            height: 'calc(100% - 20px)'
                          }}>
                            <label htmlFor="description" className="font-weight-bold text-cyan">
                              Fatura Açıklaması
                            </label>
                            <textarea
                              name="description"
                              id="description"
                              className="form-control"
                              placeholder="Fatura ile ilgili notlarınızı buraya yazabilirsiniz..."
                              value={formData.description}
                              onChange={this.handleChange}
                              style={{
                                borderRadius: '6px',
                                border: '1px solid #ced4da',
                                fontSize: '14px',
                                resize: 'none',
                                height: 'calc(100% - 60px)',
                                minHeight: '300px'
                              }}
                            />
                            <small className="form-text text-muted" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                              <i className="fa fa-info-circle" style={{ marginRight: '6px' }}></i>
                              Bu açıklama fatura üzerinde görünecektir.
                            </small>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Ürün/Hizmet Kalemleri */}
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="card">
                  <div className="header" style={{
                    background: '#f8f9fa',
                    borderBottom: '2px solid #dee2e6',
                    padding: '20px'
                  }}>
                    <h2 style={{ color: '#495057', margin: 0, display: 'flex', alignItems: 'center', fontWeight: '600', fontSize: '16px' }}>
                      <i className="fa fa-shopping-cart" style={{ marginRight: '12px', color: '#6c757d' }}></i>
                      Ürün/Hizmet Kalemleri
                    </h2>
                  </div>
                  <div className="body">
                    {/* KDV Uygula ve Bakım Şablonu */}
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <label
                        htmlFor="setKdv"
                        style={{
                          background: '#fff',
                          padding: '10px 15px',
                          borderRadius: '6px',
                          border: '1px solid #dee2e6',
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          margin: 0,
                          fontSize: '14px',
                          fontWeight: '500'
                        }}
                      >
                        <input
                          name="setKdv"
                          id="setKdv"
                          type="checkbox"
                          checked={this.state.setKdv}
                          onChange={this.handleSetKdvChange}
                          style={{ marginRight: '8px' }}
                        />
                        <span>Tümüne KDV Uygula (%20)</span>
                      </label>

                      <button
                        title="Bakım İşlemleri Ekle"
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={this.handleAddMaintenanceProcess}
                        style={{
                          borderRadius: '6px',
                          padding: '10px 20px',
                          fontWeight: '500',
                          fontSize: '14px'
                        }}
                      >
                        <i className="fa fa-wrench"></i> Bakım Şablonu
                      </button>
                    </div>

                    {/* Item Listesi */}

                    {processes.map((process, index) => (
                      <div key={index} style={{
                        background: '#fff',
                        padding: '20px',
                        borderRadius: '8px',
                        border: '2px solid #dee2e6',
                        marginBottom: '15px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                      }}
                        className="form-row align-items-end">
                        <div className="col-lg">
                          <label htmlFor={`process-${index}`} className="font-weight-bold text-cyan">
                            Ürün/Hizmet <span className="text-danger">*</span>
                          </label>
                          <div className="modern-dropdown-wrapper">
                            <input
                              type="text"
                              className="form-control"
                              id={`process-${index}`}
                              placeholder="Ürün veya hizmet ara..."
                              value={process.process}
                              onChange={(e) => this.handleProcessChange(index, "process", e.target.value)}
                              onFocus={() => this.setState({ showDropdown: index })}
                              autoComplete="off"
                            />
                            {this.state.showDropdown === index && (
                              <div
                                className="modern-dropdown-menu"
                                onTouchStart={(e) => e.stopPropagation()}
                                onTouchMove={(e) => e.stopPropagation()}
                              >
                                {this.state.filteredProcessNames.length > 0 ? (
                                  this.state.filteredProcessNames.map((nameObj) => (
                                    <div
                                      key={nameObj.name}
                                      onClick={() => this.handleProcessSelect(index, nameObj.name.trim())}
                                      className="modern-dropdown-item"
                                    >
                                      <div className="modern-dropdown-item-icon">
                                        <i className="fa fa-cube"></i>
                                      </div>
                                      <span className="modern-dropdown-item-text">
                                        {nameObj.name.trim()}
                                      </span>
                                    </div>
                                  ))
                                ) : (
                                  <div className="modern-dropdown-empty">
                                    <div className="modern-dropdown-empty-icon">
                                      <i className="fa fa-search"></i>
                                    </div>
                                    <p className="modern-dropdown-empty-text">
                                      Sonuç bulunamadı
                                    </p>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`unit-${index}`} className="font-weight-bold text-cyan">Birim</label>
                          <select
                            id={`unit-${index}`}
                            className="form-control"
                            value={process.unit}
                            onChange={(e) => this.handleProcessChange(index, "unit", e.target.value)}
                          >
                            <option value="">Seçiniz</option>
                            <option value="C62">Adet</option>
                            <option value="KGM">Kg</option>
                            <option value="LTR">Litre</option>
                            <option value="MTR">Metre</option>
                            <option value="MTK">Metre Kare</option>
                            <option value="MTQ">Metre Küp</option>
                            <option value="PR">Çift</option>
                          </select>
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`quantity-${index}`} className="font-weight-bold text-cyan">Miktar</label>
                          <input
                            type="number"
                            className="form-control"
                            id={`quantity-${index}`}
                            placeholder="Miktar"
                            value={process.quantity}
                            onChange={(e) => this.handleProcessChange(index, "quantity", e.target.value)}
                          />
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`kdv-${index}`} className="font-weight-bold text-cyan">
                            KDV (%) <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id={`kdv-${index}`}
                            placeholder="KDV Oranı"
                            value={process.kdv}
                            onChange={(e) => this.handleProcessChange(index, "kdv", e.target.value)}
                          />
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`discount-${index}`} className="font-weight-bold text-cyan">İndirim (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            id={`discount-${index}`}
                            placeholder="İndirim Oranı"
                            value={process.discount}
                            onChange={(e) => this.handleProcessChange(index, "discount", e.target.value)}
                          />
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`cost-${index}`} className="font-weight-bold text-cyan">
                            Maliyet (₺)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id={`cost-${index}`}
                            placeholder="0.00"
                            value={process.cost}
                            onChange={(e) => this.handleProcessChange(index, "cost", e.target.value)}
                          />
                        </div>
                        <div className="col-lg">
                          <label htmlFor={`price-${index}`} className="font-weight-bold text-cyan">
                            Tutar (₺) <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id={`price-${index}`}
                            placeholder="Tutar"
                            value={process.price}
                            onChange={(e) => this.handleProcessChange(index, "price", e.target.value)}
                          />
                        </div>
                        <div className={isMobile ? 'col-lg mt-2' : 'col-auto'}>
                          {index > 0 ? (
                            <button
                              type="button"
                              className="btn btn-outline-danger w-100"
                              onClick={() => this.handleRemoveProcess(index)}
                              title="Satırı Sil"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-outline-success w-100"
                              onClick={this.handleAddProcess}
                              title="Yeni Satır Ekle"
                            >
                              <i className="fa fa-plus"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    ))}

                    {/* Fiyat Özeti - Sağ tarafta kompakt */}
                    <div className="row" style={{ marginTop: '20px' }}>
                      <div className="col-lg-8 col-md-12">
                        {/* Boş alan - sol taraf */}
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div style={{
                          background: '#fff',
                          padding: '20px',
                          borderRadius: '8px',
                          border: '2px solid #dee2e6',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{
                            marginBottom: '15px',
                            paddingBottom: '10px',
                            borderBottom: '2px solid #e9ecef'
                          }}>
                            <h6 className="font-weight-bold text-cyan" style={{ margin: 0, fontSize: '13px' }}>
                              <i className="fa fa-calculator" style={{ marginRight: '8px' }}></i>
                              Fiyat Özeti
                            </h6>
                          </div>

                          {/* Hesap Kalemleri */}
                          <div style={{ marginBottom: '15px' }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 0',
                              borderBottom: '1px solid #f0f0f0',
                              fontSize: '13px'
                            }}>
                              <span style={{ color: '#6c757d' }}>Toplam Maliyet</span>
                              <span style={{ fontWeight: '600', color: '#495057' }}>{formattedPrice(totalCost)}</span>
                            </div>

                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 0',
                              borderBottom: '1px solid #f0f0f0',
                              fontSize: '13px'
                            }}>
                              <span style={{ color: '#6c757d' }}>Ara Toplam</span>
                              <span style={{ fontWeight: '600', color: '#495057' }}>{formattedPrice(totalPrice)}</span>
                            </div>

                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 0',
                              borderBottom: '1px solid #f0f0f0',
                              fontSize: '13px'
                            }}>
                              <span style={{ color: '#6c757d' }}>KDV</span>
                              <span style={{ fontWeight: '600', color: '#28a745' }}>+ {formattedPrice(totalKdv)}</span>
                            </div>

                            {parseFloat(totalDiscount) > 0 && (
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: '13px'
                              }}>
                                <span style={{ color: '#6c757d' }}>İndirim</span>
                                <span style={{ fontWeight: '600', color: '#ffc107' }}>- {formattedPrice(totalDiscount)}</span>
                              </div>
                            )}

                            {parseFloat(totalWithholding) > 0 && (
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: '13px'
                              }}>
                                <span style={{ color: '#6c757d' }}>Tevkifat</span>
                                <span style={{ fontWeight: '600', color: '#dc3545' }}>- {formattedPrice(totalWithholding)}</span>
                              </div>
                            )}
                          </div>

                          {/* Genel Toplam */}
                          <div style={{
                            background: '#007bff',
                            padding: '15px',
                            borderRadius: '6px',
                            textAlign: 'center',
                            marginBottom: '15px'
                          }}>
                            <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.9)', marginBottom: '5px', fontWeight: '600' }}>
                              GENEL TOPLAM
                            </div>
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff' }}>
                              {formattedPrice(totalWithKdv)}
                            </div>
                          </div>

                          {/* Butonlar */}
                          <button
                            type="button"
                            onClick={this.toggleWithholdingModal}
                            className="btn btn-outline-info btn-block"
                            style={{
                              marginBottom: '10px',
                              padding: '10px',
                              borderRadius: '6px',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}
                          >
                            <i className="fa fa-percent"></i> Tevkifat Ekle
                          </button>

                          {loading ? (
                            <button
                              className="btn btn-primary btn-block"
                              disabled
                              style={{
                                padding: '12px',
                                fontSize: '14px',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px'
                              }}
                            >
                              <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                              Lütfen Bekleyin...
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary btn-block"
                              type="button"
                              onClick={this.handleSubmit}
                              style={{
                                padding: '12px',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}
                            >
                              <i className="fa fa-check-circle"></i> Faturayı Oluştur
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tevkifat Modal */}
            <WithholdingModal
              isOpen={showWithholdingModal}
              toggle={this.toggleWithholdingModal}
              selectedTevkifat={selectedTevkifat}
              tevkifatOptions={tevkifat}
              showDeleteButton={false}
              tevLoading={false}
              tevDelLoading={false}
              totalWithholding={totalWithholding}
              totalWithKdv={totalWithKdv}
              handleTevkifatChange={this.handleTevkifatChange}
              handleWithholdingSubmit={(e) => {
                e.preventDefault();
                this.toggleWithholdingModal();
              }}
              handleDeleteWithholding={null}
              code={code}
              formattedPrice={formattedPrice}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default subscriptionPermissionsControl(
  withPermissions(
    withRouter(
      connect(mapStateToProps, {})(ManualInvoice)
    )
  )
);

